/** Klucz zgody na cookies (współdzielony z CookieConsentBanner). */
export const PDS_COOKIE_CONSENT_KEY = 'pds_cookie_consent'

const DEFAULT_CLARITY_PROJECT_ID = 'wplb5lguym'

type ClarityFn = (...args: unknown[]) => void

let clarityStoppedForAdmin = false

export function clarityProjectId(): string {
  const fromEnv = import.meta.env.VITE_CLARITY_PROJECT_ID
  if (fromEnv === undefined || fromEnv === null) return DEFAULT_CLARITY_PROJECT_ID
  const trimmed = String(fromEnv).trim()
  return trimmed || DEFAULT_CLARITY_PROJECT_ID
}

export function hasPdsCookieConsent(): boolean {
  try {
    return typeof window !== 'undefined' && localStorage.getItem(PDS_COOKIE_CONSENT_KEY) === '1'
  } catch {
    return false
  }
}

/** Panel admina nie trafia do Clarity (nagrania, heatmapy). */
export function isClarityExcludedPath(pathname: string): boolean {
  return pathname === '/admin' || pathname.startsWith('/admin/')
}

function getClarity(): ClarityFn | null {
  const w = window as unknown as { clarity?: ClarityFn }
  return typeof w.clarity === 'function' ? w.clarity : null
}

function callClarity(...args: unknown[]) {
  const clarity = getClarity()
  if (clarity) {
    clarity(...args)
  }
}

/** Zgoda na cookie analityczne Clarity — bez tego (gdy w projekcie włączony consent mode) każda wizyta = „nowy” użytkownik. */
export function applyClarityCookieConsent(granted: boolean) {
  if (isClarityExcludedPath(window.location.pathname)) return
  if (granted) {
    callClarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' })
  } else {
    callClarity('consent', false)
  }
}

export function identifyClarityUser(userId: string | null, pathname: string) {
  if (!userId || isClarityExcludedPath(pathname)) return
  callClarity('identify', userId)
}

function injectClarityScript(projectId: string) {
  if (typeof document === 'undefined' || !projectId) return
  if (document.getElementById('clarity-script')) return

  const w = window as Window & { clarity?: ClarityFn & { q?: unknown[][] } }
  w.clarity =
    w.clarity ||
    function (...args: unknown[]) {
      ;(w.clarity!.q = w.clarity!.q || []).push(args)
    }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`
  script.id = 'clarity-script'
  const first = document.getElementsByTagName('script')[0]
  first?.parentNode?.insertBefore(script, first)
}

/**
 * Wyłącza Clarity na /admin/*; po wyjściu z admina ponownie ładuje skrypt (SPA).
 */
export function syncClarityForRoute(pathname: string) {
  if (isClarityExcludedPath(pathname)) {
    clarityStoppedForAdmin = true
    callClarity('stop')
    return
  }

  if (clarityStoppedForAdmin) {
    clarityStoppedForAdmin = false
    injectClarityScript(clarityProjectId())
    if (hasPdsCookieConsent()) {
      applyClarityCookieConsent(true)
    }
  }
}

